import { Seo } from '../components/Seo';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import './Services.css';

const Services = () => {
  return (
    <>
      <Seo
        title="Our Services - Schwabe.net"
        description="Advanced Data Science, Curated Data Sets, and AI Business Process Augmentation."
        type="webapp"
      />
      <Header selectedNavitem="services" />

      <div className="services-hero text-center">
        <div className="container">
          <h1 className="display-4 fw-bold mb-3">2026 Core Services</h1>
          <p className="lead">
            Empowering businesses with world-class data science, curated data solutions, and intelligent process automation.
          </p>
        </div>
      </div>

      <div className="container mb-5 pb-5">
        <div className="row g-4">
          {/* Service 1: Advanced Data Science */}
          <div className="col-lg-4 d-flex align-items-stretch">
            <div className="service-card w-100">
              <div className="service-icon">
                <i className="bi bi-graph-up-arrow"></i>
              </div>
              <h2>Advanced Data Science</h2>
              <p>
                Unlock the predictive power of your data with our deep expertise in mathematical modeling and analysis.
              </p>
              <ul className="feature-list">
                <li>World-class time series forecasting</li>
                <li>Complex pattern recognition</li>
                <li>Predictive analytics & modeling</li>
                <li>Custom algorithm development</li>
              </ul>
            </div>
          </div>

          {/* Service 2: Curated Data Set Creation */}
          <div className="col-lg-4 d-flex align-items-stretch">
            <div className="service-card w-100">
              <div className="service-icon">
                <i className="bi bi-database-check"></i>
              </div>
              <h2>Curated Data Creation</h2>
              <p>
                We design robust systems for data collection and offer managed access to high-value industry datasets.
              </p>
              <ul className="feature-list">
                <li>Automated data collection systems</li>
                <li>Data quality & validation pipelines</li>
                <li>Managed dataset subscriptions</li>
                <li>Niche industry data intelligence</li>
              </ul>
            </div>
          </div>

          {/* Service 3: AI Business Augmentation */}
          <div className="col-lg-4 d-flex align-items-stretch">
            <div className="service-card w-100">
              <div className="service-icon">
                <i className="bi bi-cpu"></i>
              </div>
              <h2>AI Process Augmentation</h2>
              <p>
                Transform your workflows with privacy-minded AI that augments human capability rather than replacing it.
              </p>

              <div className="highlight-use-case">
                <h4>Highlighted Use Case</h4>
                <p>
                  <strong>Semi-Automated Software Engineering:</strong> A governance-supervised pipeline that automates routine coding tasks using modern, privacy-first AI models while keeping humans in the loop for critical decision making.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
};

export default Services;